import { useSelectedDatabaseId } from 'apps/sigma2-ui/src/lib/hooks/useSelectedDatabaseId';
import { useSelectedDatabaseRevisionId } from 'apps/sigma2-ui/src/lib/hooks/useSelectedDatabaseRevisionId';
import { useSelectedOrganizationId } from 'apps/sigma2-ui/src/lib/hooks/useSelectedOrganizationId';
import { useSelectedDashboardDatabaseRevisionId } from 'apps/sigma2-ui/src/lib/hooks/useSelectedDashboardDatabaseRevisionId';
import { useMemo } from 'react';

export const useLoadingObservationIds = (params?: {
  isDashboardDetailPage?: boolean;
}): {
  databaseId: string | null;
  databaseRevisionId: string | null;
  organizationId: string | null;
} => {
  const databaseId = useSelectedDatabaseId();
  const rawDatabaseRevisionId = useSelectedDatabaseRevisionId();
  const organizationId = useSelectedOrganizationId();
  const dashboardDatabaseRevisionId = useSelectedDashboardDatabaseRevisionId();
  const databaseRevisionId = useMemo(
    () =>
      params?.isDashboardDetailPage
        ? dashboardDatabaseRevisionId || rawDatabaseRevisionId
        : rawDatabaseRevisionId,
    [
      params?.isDashboardDetailPage,
      dashboardDatabaseRevisionId,
      rawDatabaseRevisionId,
    ],
  );

  return useMemo(() => {
    return {
      databaseId,
      databaseRevisionId,
      organizationId,
    };
  }, [databaseId, databaseRevisionId, organizationId]);
};
